import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadDetailsData } from './actions'

function mapStateToProps(state, hocProps) {
    const module = hocProps?.module
    const id = hocProps?.id
    const block = hocProps?.block
    const tenderId = hocProps?.tenderId
    const customDataPath = [
        'ui',
        'workspace',
        module,
        id,
        'blocks',
        block,
        'customData',
        'wonTenders',
        'details',
        tenderId,
        'parts',
    ]

    return {
        isLoading: state.getIn([...customDataPath, 'isLoading'], false),
        procurementParts: state.getIn([...customDataPath, 'procurementParts'], []),
        pagination: state.getIn([...customDataPath, 'query', 'pagination'], {}),
        sorted: state.getIn([...customDataPath, 'query', 'sorted'], []),
        filter: state.getIn([...customDataPath, 'query', 'filter'], {}),
        loaded: state.getIn([...customDataPath, 'loaded'], false),
        failed: state.getIn([...customDataPath, 'failed'], false),
        dataLocale: state.getIn([...customDataPath, 'dataLocale'], null),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadDetailsData,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
